var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"auth-full-bg pt-lg-5 p-4 h-auto"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"bg-overlay bg-overlay-background"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }